import { IUpdateItemProcessoRiscosInteresseUseCase } from "../../../presentation/useCases/update/updade_item_processo_riscos_interesse_servicos_use_case";
import { IQualidadeRepository } from "../../repositories/qualidade_repository";

// UpdateProcessoRiscosInteresseUseCase


export class UpdateItemProcessoRiscosInteresseUseCase implements IUpdateItemProcessoRiscosInteresseUseCase {
  constructor(private readonly repository: IQualidadeRepository) {}

  async updateItemProcessoRiscosInteresse(IdItemProcessoInteresse: number, IdItemProcesso: number, Descricao: string | null, Expectativa: string | null, Acompanhamento: string | null, ResultadosAlcancados: string | null): Promise<void> {
    
    await this.repository.updateItemProcessoRiscosInteresse(IdItemProcessoInteresse, IdItemProcesso, Descricao, Expectativa, Acompanhamento, ResultadosAlcancados);
  }
}
